<dx-popup
  [width]="760"
  [height]="710"
  [showTitle]="true"
  class="transport-intervention-report-popup"
  [title]="title"
  [dragEnabled]="true"
  [closeOnOutsideClick]="false"
  [elementAttr]="{ class: 'transport-intervention-report-popup' }"
  (onHidden)="closed($event)"
  (onShowing)="onShowing($event)"
  (onShown)="onShown($event)"
  [(visible)]="visible">

  <dxi-toolbar-item
    widget="dxButton"
    toolbar="bottom"
    location="after"
    [options]="{
            text: 'Fermer',
            onClick: close
        }">
  </dxi-toolbar-item>

  <div *dxTemplate="let data of 'content'">
    <dx-tabs
      [elementAttr]="{class: 'transport-interventions-report-tabs'}"
      [dataSource]="tabs"
      [(selectedIndex)]="selectedIndex"
      (onItemClick)="selectTab($event)"
    ></dx-tabs>
    <app-transport-interventions-metrics
      [hidden]="selectedIndex !== 0"
      [intervention]="intervention"
      [poiListGroupReport]="poiListGroupReport"></app-transport-interventions-metrics>
    <app-transport-interventions-timeline
      [hidden]="selectedIndex !== 1"
      [intervention]="intervention"
      [poiList]="poiList"
      [poiListGroupReport]="poiListGroupReport"></app-transport-interventions-timeline>
    <app-transport-intervention-map
      [hidden]="selectedIndex !== 2"
      [intervention]="intervention"
      [poiList]="poiList"
      [poiListGroupReport]="poiListGroupReport"
      [closed]="closed$"></app-transport-intervention-map>

  </div>
</dx-popup>

<dx-load-panel
  shadingColor="rgba(0,0,0,0.1)"
  [position]="{ of: '.transport-intervention-report-popup' }"
  [visible]="loadingVisible"
  [showIndicator]="true"
  [showPane]="false"
  [shading]="true"
  [closeOnOutsideClick]="false">
</dx-load-panel>
